/* Переводим из копеек в рубли */
export const toRubles = (num: number | string): number => {
  const x = +num;
  const result = (x / 100).toFixed(2);

  return +result;
};

/* Переводим в рубли с разделением по разрядам */
export const toFractionRubles = (value: number | string) => {
  const num = toRubles(value).toFixed(2);

  return num.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
};

/* Переводим в рубли с разделением по разрядам */
export const toFractionSpaceRubles = (value: number | string) => {
  const num = toRubles(value).toFixed(2);

  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/* Переводим в копейки из рублей */
export const toKopek = (num: number | string): number => {
  const x = +num;
  const result = Math.round(x * 100);

  return +result;
};

/* Возвращает сумму значений из массива объектов с полем value */
export const getFullSum = (arr: { [key: string]: any }[]): number => {
  let result = 0;

  if (arr) {
    arr.forEach((item) => {
      result += item.value;
    });
  }

  return result;
};

/* Возвращает отформатированную строку с задолженностью/переплатой */
export const debtStatus = (value: number, withoutText?: boolean): string => {
  const formattedValue: string = toFractionRubles(value).replace('-', '');

  if (value === 0 || withoutText) {
    return `${formattedValue} руб.`;
  }

  return value > 0
    ? `Долг ${formattedValue} руб.`
    : `Переплата ${formattedValue} руб.`;
};
